import { atomWithStorage } from "jotai/utils";

// Controla el estado de bloqueo del grid (persiste en localStorage)
export const atomGridLocked = atomWithStorage("dashboard-grid-locked", true);
